import * as c from '@chakra-ui/react'
import { TranslateOptions, translateText } from 'src/utils/translateText'

import Carousel from '../carousel'
import { ArrowRightIcon } from '../icons/arrow-right.icon'

interface NewsProps {
  newsBanner: {
    title: TranslateOptions
    subtitle: TranslateOptions
    blogCard: {
      text: TranslateOptions
      cta: TranslateOptions
      url: string
    }
    items: CardNewsProps[]
    idSection?: string
  }
}

interface CardNewsProps {
  image: string
  magazine: string
  title: string
  cta: string
  url: string
}

export default function News({ newsBanner }: NewsProps) {
  const [isMobile] = c.useMediaQuery('(max-width: 720px)')

  const LastCard = () => (
    <c.Flex
      p="s3"
      bg="primary.500"
      borderRadius="20px"
      h={['123px', '260px']}
      w={['full', '294px']}
      direction="column"
      align="center"
      justify="center"
      gap="s5"
      id={newsBanner?.idSection}
    >
      <c.Heading color="black.0" fontSize="h-xs.0" textAlign="center">
        {translateText(newsBanner?.blogCard?.text)}
      </c.Heading>

      <c.Button
        as={c.Link}
        isExternal
        href={newsBanner?.blogCard?.url}
        variant="light"
        rightIcon={
          <c.Icon as={ArrowRightIcon} color="primary.500" h="12px" w="12px" />
        }
        color="primary.500"
        fontSize="t-sm.1"
        maxH="37px"
        borderRadius="full"
      >
        {translateText(newsBanner?.blogCard?.cta)}
      </c.Button>
    </c.Flex>
  )

  return (
    <c.Container px={['s5', 0]}>
      <c.Box p="s5" bg="black.0" borderRadius="20px">
        <c.Box>
          <c.Heading size="md" textAlign="center" mb="s3">
            {translateText(newsBanner?.title)}
          </c.Heading>
          <c.Text fontSize="t-md.1" textAlign="center" mb="m4">
            {translateText(newsBanner?.subtitle)}
          </c.Text>
        </c.Box>

        <c.Flex direction={['column', 'row']} gap="l2">
          <c.Box maxW={['full', 'full']}>
            <Carousel
              data={newsBanner?.items}
              Content={Content}
              slidesPerView={isMobile ? 1 : 3.6}
              hasLastCard={LastCard}
            />
          </c.Box>
        </c.Flex>
      </c.Box>
    </c.Container>
  )
}

function Content({ data }: { data: CardNewsProps }) {
  return (
    <c.Box w={['full', '294px']}>
      <c.Image
        src={data.image}
        h="120px"
        w="full"
        objectFit="cover"
        objectPosition={['center', '100% 10%']}
        borderRadius="20px 20px 0 0"
      />

      <c.Flex
        p="s3"
        h="140px"
        bg="black.0"
        direction="column"
        justify="space-between"
        borderRadius="0 0 20px 20px"
        shadow="light"
      >
        <c.Box>
          <c.Text
            color="blue.500"
            fontSize="t-xs.0"
            fontWeight="bold"
            textTransform="lowercase"
            mb="s1"
          >
            {data.magazine}
          </c.Text>
          <c.Heading fontSize="h-xs.0" mb="s2">
            {data.title}
          </c.Heading>
        </c.Box>

        <c.Button
          as={c.Link}
          isExternal
          href={data.url}
          size="xs"
          variant="secondary"
          fontSize="t-sm.0"
          fontWeight="bold"
          maxW="fit-content"
          borderColor="transparent"
          rightIcon={
            <c.Icon as={ArrowRightIcon} color="primary.500" h="10px" w="10px" />
          }
        >
          {data.cta}
        </c.Button>
      </c.Flex>
    </c.Box>
  )
}
